import { Suspense } from 'react';
import { SpotlightSearch, TasksTopBarToggle, UserProfile } from '@features';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { Center, Flex, Group, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Logo, WebSocketConnectionIndicator } from './components';
import classes from './TopBar.module.css';

type TopBarPropsType = {
  toggleMobile: () => void;
  toggleDesktop: () => void;
  toggleTasks: () => void;
};

export const TopBar: React.FC<TopBarPropsType> = ({
  toggleDesktop,
  toggleMobile,
  toggleTasks,
}) => {
  const { t } = useTranslation();
  const { hasPermission } = usePermissionContext();

  const userCanReadTasks = hasPermission({
    permission: 'TASKS',
    action: 'READ',
  });

  return (
    <Flex className={classes.topBarRoot}>
      <Group gap="lg" wrap="nowrap">
        <Logo toggleMenu={toggleMobile} hiddenFrom="sm" />
        <Logo toggleMenu={toggleDesktop} visibleFrom="sm" />
        <SpotlightSearch />
      </Group>
      <Center>
        <Text
          visibleFrom="sm"
          style={{
            fontFamily: 'Ivy Journal',
            fontSize: '1.620rem',
            color: 'var(--mantine-color-text-4)',
          }}
          truncate
        >
          {t('HEADER.TITLE')}
        </Text>
      </Center>
      <Group mr="sm">
        <WebSocketConnectionIndicator />
        <Suspense>
          <UserProfile />
        </Suspense>
        {userCanReadTasks && <TasksTopBarToggle onClick={toggleTasks} />}
      </Group>
    </Flex>
  );
};
